// extracted by mini-css-extract-plugin
module.exports = {"SideBarContainer":"style_SideBarContainer__3JAs1"};